import { Component, OnInit, Input, ViewChild, SimpleChanges, forwardRef } from '@angular/core';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { 
    NavController, IonGrid, IonRow, IonCol, IonSpinner
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { MarvButtonComponent, MarvCircleComponent, MarvToggleComponent, MarvDrawerComponent, MarvMessageComponent } from '@marv/components';
import { OperationItemComponent, OperationItem, StoreListComponent, StoreItemComponent, StoreItem } from '@app/components';
import { OperationService } from '@app/services';
import { OperationCard } from '@app/models';

@Component({
    selector: 'app-my-operation',
    templateUrl: './my-operation.component.html',
    styleUrls: ['./my-operation.component.scss'],
    imports: [
        ReactiveFormsModule, IonGrid, IonRow, IonCol, IonSpinner, TranslatePipe, forwardRef(() => MarvMessageComponent), forwardRef(() => MarvButtonComponent),
        forwardRef(() => MarvCircleComponent), forwardRef(() => MarvToggleComponent), forwardRef(() => MarvDrawerComponent), 
        forwardRef(() => OperationItemComponent), forwardRef(() => StoreListComponent), forwardRef(() => StoreItemComponent)
    ]
})
export class MyOperationComponent  implements OnInit {

    @Input({alias : 'typesMissions', required : false}) typesMissions: Array<string> = [];
    @Input({alias : 'displayActiveOperationToggle', required : false}) displayActiveOperationToggle: boolean = true;;
    @Input({alias : 'displayStoreSearch', required : false}) displayStoreSearch: boolean = true;;

    isFetching: boolean = false;
    operationsItems: Array<OperationItem> = [];
    operationsItemsDisplayed: Array<OperationItem> = [];
    operationsForm: FormGroup = new FormGroup({
        activesOnly: new FormControl(true)
    });    
    storeSelected: StoreItem|null = null;
    operationsSubscription: Subscription; 

    @ViewChild('drawerStoresList') drawerStoresList: MarvDrawerComponent;

    constructor(        
        private navController: NavController
    ) { }

    async ngOnInit() {
        
        this.isFetching = true;
        let operationsItems: Array<OperationItem> = [];
        let operations = OperationService.Operations;  
        if(operations){
            for(let o of operations){
                if(o.type === 'loga'){
                    operationsItems.push(OperationItem.FromOperationCard(o));
                }
            }
        }  
        this.operationsItems = operationsItems;
         
        this.getOperationsItems();
        this.operationsSubscription = this.operationsForm.controls['activesOnly'].valueChanges.subscribe(newValue => {
           this.getOperationsItems();
        });    
        this.isFetching = false;
    }
    
    ngOnDestroy() {
        if(this.operationsSubscription){
            this.operationsSubscription.unsubscribe();
        }        
    }
    
    ngOnChanges(changes: SimpleChanges) {
        if(changes['typesMissions']){
            this.getOperationsItems();
        }
    }
    
    getOperationsItems(){        
        this.operationsItemsDisplayed = this.operationsItems.filter(o => 
            (!this.operationsForm.controls['activesOnly'].value || !o.hiddenByDefault)
            && (this.typesMissions.length === 0 || this.typesMissions.indexOf(o.type) !== -1)
        );         
    }
    
    searchStore() {
        this.drawerStoresList.open();  
    }
        
    onSelectStore(storeItem: StoreItem){
        this.storeSelected = storeItem;
        this.drawerStoresList.close(false);
    }
    
    onDidDismissDrawerStoresList($event: any){
        if($event.detail?.data?.resetDrawer){
            
        }               
    }
    
    unselectStore(){
        this.storeSelected = null;
    }    
    
    addIntervention(operationItem: OperationItem){
        let params: any = {
            operationId: operationItem.id
        };
        if(this.storeSelected){
            params.storeId = this.storeSelected.id;
        }        
        this.navController.navigateRoot('mission-add', {queryParams: params});
    }
    
}
